// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1socJ","rootMobile":"styles_rootMobile__fZ7A0"};